<template>
  <div class="main-content projectFolder">
    <div class="projectFolder-top-nav">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="活跃中" name="active">
          <div slot="label" class="tabs-item">
            <span><img src="image/icon/icon_active@2x.png" alt="">活跃中</span>
            <span class="count-number" v-if="countList.active">（{{countList.active > 99 ? '99+' : countList.active}}）</span>
          </div>
        </el-tab-pane>
        <el-tab-pane label="已冻结" name="sleep">
          <div slot="label" class="tabs-item">
            <span>已冻结</span>
            <span class="count-number" v-if="countList.sleep">（{{countList.sleep > 99 ? '99+' : countList.sleep}}）</span>
          </div>
        </el-tab-pane>
        <el-tab-pane label="已归档" name="archived">
          <div slot="label" class="tabs-item">
            <span>已归档</span>
            <span class="count-number" v-if="countList.archived">（{{countList.archived > 99 ? '99+' : countList.archived}}）</span>
          </div>
        </el-tab-pane>
        <el-tab-pane label="已删除" name="delete">
          <div slot="label" class="tabs-item">
            <span>已删除</span>
            <span class="count-number" v-if="countList.delete">（{{countList.delete > 99 ? '99+' : countList.delete}}）</span>
          </div>
        </el-tab-pane>
      </el-tabs>
      <wf-button class="add-project-btn" icon="icon iconfont iconicon_enlarge" v-permission="['项目管理-新增项目']" @click="add">新建项目</wf-button>
    </div>
    <div class="project-wrap" v-if="activeName === 'active'"  v-loading="loading">
      <div class="block-box" style="border-bottom: none">
        <div class="block-content" :style="{'min-height': dataList.joined.length == 0 && !loading ? '400px' : 'auto'}" :ref="'conten'" v-if="(dataList.not_joined && dataList.not_joined.length > 0) || (dataList.joined && dataList.joined.length > 0)">
          <div class="closer" @click="showJoin = !showJoin">
            <i class="icon iconfont iconicon_arrow_gantt_chart1" :class="{'is-reverse': !showJoin}"></i>
            <span class="tip">已加入</span>
            <span class="count" v-if="dataList.joined.length > 0">{{dataList.joined.length}}</span>
          </div>
          <vuedraggable v-if="showJoin" class="folder-project-list" v-bind="dragOptions" :list="dataList.joined" @end="projectOrderByEnd">
            <PojectItem v-for="innerItem in dataList.joined" :key="innerItem.project_id" :depId="innerItem.project_depart_id" :projectInfo="innerItem" @click.native="viewProject(innerItem)" @starSuccess="starSuccess" :disabled="!innerItem.permissions">
            </PojectItem>
          </vuedraggable>
          <div v-if="dataList.joined.length == 0 && !loading && dataList.not_joined.length > 0" class="no-project-txt">
            <nothing :config="{btnText:$permission('项目管理-新增项目') && activeName === 'active'? '新建项目' : '',tip:'暂无活跃项目，快去添加项目'}" @button-click="add"></nothing>
          </div>
        </div>

        <div class="block-content" :ref="'conten'" v-if="dataList.not_joined && dataList.not_joined.length > 0">
          <div class="closer" @click="showNotJoin = !showNotJoin">
            <i class="icon iconfont iconicon_arrow_gantt_chart1"  :class="{'is-reverse': !showNotJoin}"></i>
            <span class="tip">未加入</span>
            <span class="count" v-if="dataList.not_joined.length > 0">{{dataList.not_joined.length}}</span>
          </div>
          <vuedraggable v-if="showNotJoin" class="folder-project-list" v-bind="dragOptions" :list="dataList.not_joined" @end="projectOrderByEnd">
            <PojectItem v-for="innerItem in dataList.not_joined" :key="innerItem.project_id" :depId="innerItem.project_depart_id" :projectInfo="innerItem" disabled readonly>
            </PojectItem>
          </vuedraggable>
        </div>
      </div>
      <div v-if="dataList.joined.length == 0 && dataList.not_joined.length === 0 && !loading" class="no-project-txt">
        <nothing :config="{btnText:$permission('项目管理-新增项目') && activeName === 'active'? '新建项目' : '',tip:'暂无活跃项目，快去添加项目'}" @button-click="add"></nothing>
      </div>
    </div>
    <projectall v-else :defStatus="activeName" @fetchProjectList="fetchProjectList" @button-click="add"  v-loading="loading"></projectall>
    <AddProjectDialog v-if="visibleAdd" v-model="visibleAdd" :queryData="queryData" @success="addSuccess"></AddProjectDialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import PojectItem from "./projectItem";
import vuedraggable from "vuedraggable";
import bus from '@/bus'
import projectall from './projectall'
import api from '@/services/api/project/project'
import AddProjectDialog from './add'
function sortArray(arrData, attr, type = 1) {
  return arrData.sort((first, second) => {
    return type === 1 ? first[attr] - second[attr] : second[attr] - first[attr];
  })
}
export default {
  name: "project",
  components: {
    AddProjectDialog,
    PojectItem,
    vuedraggable,
    projectall
  },
  data() {
    return {
      dataList: {
        joined: [],
        not_joined: []
      },
      showJoin: true,
      showNotJoin: true,
      departmentList: [],
      visibleAdd: false,
      loading: false,
      editVisible: false,
      project_list_id: null, //项目文件夹id
      project_depart_id: null, //项目部门id
      project_depart_name: null,
      widthSize: "410px",
      activeName: 'active',
      queryData: {},
      timer: null,
      countList: {
        active: 0,
        archived: 0,
        delete: 0,
        sleep: 0,
      }
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: !this.$permission('项目管理-新增项目')
      };
    },
    ...mapState('home/home', {
      keyword: state => state.keyword
    })
  },
  watch: {
    keyword() {
      this.debounce(this.fetchProjectList, 300)
    }
  },
  created() {
    this.project_list_id = this.$route.query.project_list_id - 0;
    this.project_depart_id = this.$route.query.project_depart_id - 0;
    this.project_depart_name = this.$route.query.project_depart_name;
    this.SET_ACTIVE(0)
    this.fetchProjectList();
    bus.$on('addProject', this.add)
  },
  mounted() {
  },
  methods: {
    ...mapActions('project/project', ['updateorderby']),
    ...mapMutations('task/task', ['SET_ACTIVE']),
    async resetCount() {
      let result = await api.getTheNumberOfProjectDifferentStatesByV2({ project_list_id: this.project_list_id, department_category_id: this.project_depart_id, keyword: this.keyword })
      this.countList = result
    },
    //防抖函数
    debounce(fn, wait) {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(fn, wait)
    },
    starSuccess() {
      this.fetchProjectList()
    },
    Color() {
      this.r = Math.floor(Math.random() * 255);
      this.g = Math.floor(Math.random() * 255);
      this.b = Math.floor(Math.random() * 255);
      return 'rgba(' + this.r + ',' + this.g + ',' + this.b + ',1)';
    },
    async fetchProjectList() {
      this.loading = true;
      this.resetCount()
      let result = await api.departmentProjectByV2({
        department_category_id: this.project_depart_id,
        project_list_id: this.project_list_id,
        project_status: 'active',
        keyword: this.keyword
      })
      this.loading = false
      this.dataList = result
    },
    viewProject(itemData) {
      this.$router.push({
        path: "/task",
        query: {
          projectId: itemData.project_id,
          isTabShow: true
        }
      });
    },
    add() {
      this.visibleAdd = true;
      this.queryData = {
        project_depart_id: this.project_depart_id,
        project_list_id: this.project_list_id
      }
    },
    addSuccess() {
      this.visibleAdd = false;
      this.fetchProjectList();
    },
    projectOrderByEnd(event) {
      // 来到这里的时候已经拿到了更新后的数据,遍历数据拼接就可以了
      let temp = [];
      let len = this.dataList?.joined?.length;
      for (let i = 0, j = len; i < len; i++, j--) {
        temp.push({
          project_id: this.dataList?.joined[i].project_id,
          orderby: j
        })
      }
      this.updateorderby({
        list: temp
      }).then(res => {
      })
    },
    goBack() {
      this.$router.go(-1);
    },
    showProjectAll(active) {
      this.$router.push({
        path: "/projectall",
        query: {
          type: active
        }
      })
    },
    handleClick() {

    }
  }
};
</script>

<style lang="scss">
.color1 {
  color: #75748e;
  margin-right: 10px;
}
.main-content {
  position: relative;
  .el-tabs__header {
    margin: 0;
  }
  .line {
    width: 4px;
    height: 14px;
    border-radius: 4px;
    display: block;
    margin-right: 16px;
  }
  .project-wrap {
    width: 100%;
    flex: 1;
    overflow: auto;
    border-radius: 16px;
    border-radius: 8px;
    // margin-top: 17px;
  }
  .project-wrap .block-content {
    transition: all 0.3s;
    position: relative;
    .closer {
      display: flex;
      align-items: center;
      font-size: 14px;
      line-height: 1;
      padding-bottom: 14px;
      cursor: pointer;
      .tip {
        font-weight: bold;
      }
      i {
        color: #C9C9C9;
        font-size: 12px;
        margin-right: 8px;
      }
      .count {
        font-size: 12px;
        color: rgba(32, 32, 32, 0.60);
        margin-left: 4px;
      }
    }
  }
  .set-maxheight {
    max-height: 225px;
  }
  .project-wrap .block-box {
    width: 100%;
    border-right: none;
    height: auto;
    position: relative;
  }
  .no-project-txt {
    width: 100%;
    height: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .more-load {
    height: 40px;
    width: 100%;
    line-height: 40px;
    text-align: center;
    // background: linear-gradient(
    //   to bottom,
    //   rgba(255, 255, 255, 0.8),
    //   rgba(255, 255, 255, 1)
    // );
    // position: absolute;
    // bottom: 0;
    // left: 0;
    // right: 0;
    // z-index: 2;
    span {
      cursor: pointer;
      font-size: 12px;
      color: #2682ff;
      .iconicon_arrow_task {
        margin-left: 8px;
      }
    }
  }
  .block-content .folder-project-list {
    display: flex;
    grid-gap: 24px;
    flex-wrap: wrap;
    overflow: hidden;
    transition: all 0.3s;
  }

  .project-type-box {
    display: flex;
    height: 30px;
    line-height: 30px;
    border: 1px solid #e7e8ed;
    border-radius: 4px;
    font-size: 14px;
    color: initial;
  }
  .project-type-item {
    cursor: pointer;
    padding: 0 16px;
  }
  .project-type-item:hover {
    color: #509aff;
    background: #dde9fb;
  }
  .project-type-item:not(:last-child) {
    border-right: 1px solid #e7e8ed;
  }
  .c-top-nav-btns {
    display: flex;
  }
  .c-top-nav-box {
    display: flex;
  }
}
.projectFolder {
  display: flex;
  flex-direction: column;
  .folder-project-list {
    overflow: visible !important;
    padding-bottom: 32px;
  }
  .block-content {
    padding-left: 40px !important;
    overflow: visible !important;
  }
  .project-wrap {
    padding-top: 17px;
  }
}
</style>

